import React,{useState,useRef} from 'react';
import s from './Profissionais.module.css';
import {Btn} from '../UI/Btn';
import {Modal} from '../UI/Modal';
import {Field,Inp,Sel} from '../UI/Inp';
import {Avatar} from '../UI/Avatar';
import {Icons} from '../Sidebar/Icons';
import {useStore} from '../../hooks/useStore';
import {store} from '../../utils/store';

function ProfModal({initial,svcs,onClose}){
  const isEdit=!!initial?.id;
  const [nome,setNome]=useState(initial?.nome||'');
  const [funcao,setFuncao]=useState(initial?.funcao||'');
  const [gen,setGen]=useState(initial?.gen||'feminino');
  const [sids,setSids]=useState(initial?.sids||[]);
  const [foto,setFoto]=useState(initial?.foto||null);
  const [fotoFile,setFotoFile]=useState(null);
  const [fotoPreview,setFotoPreview]=useState(initial?.foto||null);
  const [err,setErr]=useState('');
  const [loading,setLoading]=useState(false);
  const fileRef=useRef();
  const tog=id=>setSids(p=>p.includes(id)?p.filter(x=>x!==id):[...p,id]);

  const handleFoto=e=>{
    const file=e.target.files[0];
    if(!file)return;
    if(file.size>3*1024*1024){setErr('Foto muito grande. Máximo 3MB.');return;}
    setFotoFile(file);
    setFotoPreview(URL.createObjectURL(file));
    setErr('');
  };

  const handleSave=async()=>{
    setErr('');
    if(!nome.trim()){setErr('Informe o nome.');return;}
    setLoading(true);
    try{
      let fotoUrl=foto;

      if(isEdit){
        // Salva primeiro para ter o ID, depois faz upload se tiver foto nova
        await store.updateProfissional(initial.id,{nome:nome.trim(),funcao,gen,sids,foto:fotoUrl});
        if(fotoFile){
          fotoUrl=await store.uploadFotoProfissional(fotoFile,initial.id);
          await store.updateProfissional(initial.id,{nome:nome.trim(),funcao,gen,sids,foto:fotoUrl});
        }
      } else {
        // Cria primeiro, pega o ID, faz upload
        const novo=await store.addProfissional({nome:nome.trim(),funcao,gen,sids,foto:null});
        if(fotoFile&&novo?.id){
          fotoUrl=await store.uploadFotoProfissional(fotoFile,novo.id);
          await store.updateProfissional(novo.id,{nome:nome.trim(),funcao,gen,sids,foto:fotoUrl});
        }
      }
      onClose();
    }catch(e){setErr(e.message);}
    finally{setLoading(false);}
  };

  return(
    <Modal title={isEdit?'Editar Profissional':'Novo Profissional'} onClose={onClose}
      footer={<><Btn variant="secondary" onClick={onClose}>Cancelar</Btn><Btn onClick={handleSave} disabled={loading}>{loading?'Salvando...':isEdit?'Salvar':'Cadastrar'}</Btn></>}
      maxWidth={460}>
      {err&&<div style={{background:'var(--red-l)',color:'var(--red)',border:'0.5px solid #fca5a5',borderRadius:8,padding:'10px 14px',fontSize:13,marginBottom:14}}>⚠️ {err}</div>}

      {/* Upload de foto */}
      <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:10,marginBottom:20}}>
        <div
          onClick={()=>fileRef.current.click()}
          style={{
            width:90,height:90,borderRadius:'50%',cursor:'pointer',
            background:'var(--g100)',border:'2px dashed var(--g300)',
            display:'flex',alignItems:'center',justifyContent:'center',
            overflow:'hidden',position:'relative',transition:'border-color .15s',
          }}
        >
          {fotoPreview
            ?<img src={fotoPreview} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}}/>
            :<div style={{textAlign:'center',color:'var(--g400)'}}>
              <div style={{fontSize:24,marginBottom:4}}>📷</div>
              <div style={{fontSize:11}}>Adicionar foto</div>
            </div>
          }
        </div>
        <input ref={fileRef} type="file" accept="image/*" style={{display:'none'}} onChange={handleFoto}/>
        <button
          style={{background:'none',border:'none',color:'var(--blue)',fontSize:12,cursor:'pointer',fontFamily:'inherit'}}
          onClick={()=>fileRef.current.click()}
        >
          {fotoPreview?'Trocar foto':'Escolher foto'}
        </button>
        <p style={{fontSize:11,color:'var(--g400)',margin:0}}>JPG, PNG ou WebP • máx. 3MB</p>
      </div>

      <Field label="Nome" required><Inp value={nome} onChange={e=>setNome(e.target.value)} placeholder="Nome completo"/></Field>
      <Field label="Função"><Inp value={funcao} onChange={e=>setFuncao(e.target.value)} placeholder="Ex: Manicure, Cabeleireira"/></Field>
      <Field label="Gênero"><Sel value={gen} onChange={e=>setGen(e.target.value)}><option value="feminino">Feminino</option><option value="masculino">Masculino</option><option value="outro">Outro</option></Sel></Field>
      <Field label="Serviços que realiza">
        {svcs.length===0?<p style={{fontSize:12,color:'var(--g400)'}}>Cadastre serviços primeiro.</p>
        :<div className={s.sg}>{svcs.map(sv=><div key={sv.id} className={`${s.sp} ${sids.includes(sv.id)?s.son:''}`} onClick={()=>tog(sv.id)}>{sv.nome}</div>)}</div>}
      </Field>
    </Modal>
  );
}

export function Profissionais(){
  const {profissionais,servicos}=useStore();
  const [modal,setModal]=useState(null);
  const del=async id=>{if(window.confirm('Excluir?'))await store.deleteProfissional(id);};
  return(
    <div>
      <div style={{display:'flex',justifyContent:'flex-end',marginBottom:16}}>
        <Btn icon={<Icons.Plus/>} onClick={()=>setModal({})}>Novo Profissional</Btn>
      </div>
      {profissionais.length===0&&<div style={{textAlign:'center',color:'var(--g400)',padding:48,fontSize:13}}><p>Nenhum profissional cadastrado.</p></div>}
      <div className={s.grid}>
        {profissionais.map((p,i)=>(
          <div className={s.card} key={p.id}>
            <div className={s.head}>
              {p.foto
                ?<img src={p.foto} alt={p.nome} style={{width:46,height:46,borderRadius:'50%',objectFit:'cover',flexShrink:0,border:'2px solid var(--g200)'}}/>
                :<Avatar name={p.nome} idx={i} size={46}/>
              }
              <div><div className={s.nome}>{p.nome}</div><div className={s.func}>{p.funcao}</div></div>
            </div>
            <div className={s.tags}>
              {(p.sids||[]).map(sid=>{const sv=servicos.find(x=>x.id===sid);return sv?<span key={sid} className={s.tag}>{sv.nome}</span>:null;})}
              {(!p.sids||p.sids.length===0)&&<span className={s.ns}>Sem serviços vinculados</span>}
            </div>
            <div className={s.acts}><Btn variant="secondary" size="sm" icon={<Icons.Edit/>} onClick={()=>setModal(p)}>Editar</Btn><Btn variant="danger" size="sm" icon={<Icons.Trash/>} onClick={()=>del(p.id)}>Excluir</Btn></div>
          </div>
        ))}
      </div>
      {modal!==null&&<ProfModal initial={modal?.id?modal:null} svcs={servicos} onClose={()=>setModal(null)}/>}
    </div>
  );
}
